import React, { useState } from "react";
import { Button, Card, KeyValueList, ValueOrPlaceholder } from "@sscs/ui";
import { capitalizeFirstLetter } from "@sscs/utils";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { filterByLink } from "../../../store/issuesSlice";
import { useReportDispatch } from "../../hooks";
import { useGetReportMappingsQuery } from "../../services/shared.api";
import { SERVICE_TYPE_TO_TEXT } from "../../utils";
import { LinkToReportTab } from "../index";
import styles from "./networkingServicesList.module.scss";
const SingleService = ({ service }) => {
    const dispatch = useReportDispatch();
    const { data: reportMappings } = useGetReportMappingsQuery();
    const list = [
        {
            Provider: React.createElement(ValueOrPlaceholder, { value: service.provider }),
            Version: service.version,
            Type: SERVICE_TYPE_TO_TEXT[service.type],
            Flow: capitalizeFirstLetter(service.flow),
            Auth: service.auth ? "Required" : "Not required",
        },
    ];
    if (service.violations.length > 0) {
        list.push("Causes issues");
        list.push(service.violations.map((policyId) => [
            React.createElement(LinkToReportTab, { key: policyId, id: policyId, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE, color: "link", onClick: () => dispatch(filterByLink({
                    issue: { operation: "is", values: [policyId] },
                })) }, policyId),
            React.createElement(ValueOrPlaceholder, { key: policyId, value: reportMappings === null || reportMappings === void 0 ? void 0 : reportMappings.descriptions[policyId] }),
        ]));
    }
    return (React.createElement(Card.Card, { className: styles.service },
        React.createElement(Card.Title, null, `Remote service: ${service.name}`),
        React.createElement(Card.Content, null,
            React.createElement(KeyValueList, { list: list }))));
};
const NetworkingServicesList = ({ services, }) => {
    const [showAll, setShowAll] = useState(false);
    const MAX_LIMIT = 3;
    return (React.createElement(React.Fragment, null,
        services
            .slice(0, showAll ? services.length : MAX_LIMIT)
            .map((service) => (React.createElement(SingleService, { key: service.id, service: service }))),
        services.length > MAX_LIMIT ? (React.createElement(Button, { color: "secondary", onClick: () => setShowAll(!showAll), className: styles.button },
            "Show",
            " ",
            showAll
                ? `First ${MAX_LIMIT} services`
                : `All ${services.length} services`)) : null));
};
export default NetworkingServicesList;
//# sourceMappingURL=NetworkingServicesList.js.map